import React from "react";

const Key = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M26.675 25.663c0 4.597-3.74 8.337-8.338 8.337C13.74 34 10 30.26 10 25.663c0-3.967 2.785-7.295 6.502-8.134V3.836c0-1.012.823-1.836 1.835-1.836 1.013 0 1.836.824 1.836 1.836v.59h2.472c.705 0 1.279.544 1.279 1.213s-.574 1.213-1.28 1.213h-.049a.427.427 0 0 0-.426.427v.679c0 .235.191.426.426.426h.05c.705 0 1.279.545 1.279 1.214 0 .669-.574 1.213-1.28 1.213h-2.47v6.718c3.716.839 6.5 4.167 6.5 8.134Zm-8.338-4.693a4.693 4.693 0 1 0 0 9.386 4.693 4.693 0 0 0 0-9.386Z"
              fill={fill}
        />
    </svg>
);

export default Key;
